import { render, staticRenderFns } from "./ListDeposit.vue?vue&type=template&id=2d96f713&scoped=true&"
import script from "./ListDeposit.vue?vue&type=script&lang=ts&"
export * from "./ListDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./ListDeposit.vue?vue&type=style&index=0&id=2d96f713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96f713",
  null
  
)

export default component.exports